export default {
  navigationBarTitleText: '签名',
  pageOrientation: 'landscape',
};
